import React from 'react'
import { Card, Icon } from '@material-ui/core'
import { useModal } from 'app/ducks/modal/hooks'
import SimpleList, { Loading } from 'app/components/SimpleList/SimpleList'
import ActivityClass from '../gym/ActivityClass'
import KPICard from '../dashboard/KPICard'
import useCurrentTheme from 'app/hooks/useCurrentTheme'
import { Theme } from 'app/components/MatxTheme/themes'
import UserTypeSpecific from 'app/components/UserTypeSpecific/UserTypeSpecific'
import { USER_TYPE } from 'app/ducks/auth/types'
import useDjangoForm from 'app/hooks/useDjangoForm'
import { FormContextProvider } from 'app/contexts/FormContext'
import FormField from 'app/reusable/form/FormField'

// Only administration/management link or unlink coordinators (scenario 5 of the issue): a coordinator gets
// view-only access to the modality's pages/metrics across every one of its classes, teaching them or not.
const ModalityCoordinators = ({ id }) => {
  const formContext = useDjangoForm({
    djangoApp: 'activities',
    djangoModel: 'activity-modality',
    id,
  })
  const { loading, fields } = formContext

  if (loading || !fields) return <Loading />

  return (
    <FormContextProvider value={formContext}>
      <FormField name="coordinators" />
      <FormField name="submit_button" />
    </FormContextProvider>
  )
}

export const ActivityModalityDetails = ({ id }) => {
  return (
    <>
      <div className="mb-3">
        <KPICard
          disableDetail
          app="activities"
          name="active-activity-modality-users"
          params={{ id }}
        />
      </div>
      <UserTypeSpecific type={[USER_TYPE.MANAGER, USER_TYPE.ADMINISTRATOR]}>
        <div className="mb-3">
          <h5 className="mb-2">Coordenadores</h5>
          <ModalityCoordinators id={id} />
        </div>
      </UserTypeSpecific>
      <SimpleList
        searchable
        showPagination
        title="Turmas"
        djangoApp="activities"
        djangoModel="activity-class"
        emptyStateText="Nenhuma turma localizada para a modalidade"
        search={{ activity_modality: id }}
        paginateBy={5}
        itemComponent={ActivityClass}
      />
    </>
  )
}
const ActivityModality = ({ showActions, ...m }) => {
  const showModal = useModal()
  const currentTheme = useCurrentTheme()
  return (
    <Card
      className="px-6 py-4 mb-3 flex-center-v flex-between cursor-pointer flex-1"
      onClick={() =>
        showModal({
          title: m.description,
          children: <ActivityModalityDetails id={m.id} />,
        })
      }
    >
      <Icon className="mr-4" fontSize="large">
        {/* Tenant branding, not a feature: stays on the theme. */}
        {currentTheme === Theme.AFA ? 'sports_martial_arts' : 'sports_soccer'}
      </Icon>
      <div className="flex-1">
        <div className="card-title">{m.description}</div>
      </div>
    </Card>
  )
}

export default ActivityModality
